import { render, staticRenderFns } from "./component.vue?vue&type=template&id=d00381ce&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./component.scss?vue&type=style&index=0&id=d00381ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00381ce",
  null
  
)

export default component.exports